import { render, staticRenderFns } from "./history-content.component.vue?vue&type=template&id=296aab3e&scoped=true&"
import script from "./history-content.component.vue?vue&type=script&lang=ts&"
export * from "./history-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./history-content.component.vue?vue&type=style&index=0&id=296aab3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296aab3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
